<template>
  <div class="card p-4 shadow-sm">
    <!-- Toast de alerta -->
    <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- Encabezado -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="m-0">Gastos Generales del Hotel</h3>
      <button class="btn btn-success" @click="abrirModalRegistrar">Registrar Gasto</button>
    </div>

    <!-- Filtro por tipo -->
    <div class="mb-3 d-flex align-items-center gap-2">
      <label class="form-label mb-0">Filtrar por tipo:</label>
      <select v-model="filtroTipo" class="form-select w-auto" @change="obtenerGastos">
        <option value="">Todos</option>
        <option value="hotel">Hotel</option>
        <option value="restaurante">Restaurante</option>
      </select>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-bordered text-center align-middle">
        <thead class="table-light">
          <tr>
            <th>Fecha</th>
            <th>Tipo</th>
            <th>Descripción</th>
            <th>No. Cheque</th>
            <th>Cuenta Cheque</th>
            <th>Cantidad (Q)</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="gastos.length === 0">
            <td colspan="7">No hay gastos registrados.</td>
          </tr>
          <tr v-for="gasto in gastos" :key="gasto.IdGastoHotel">
            <td>{{ gasto.Fecha }}</td>
            <td>
              <span class="badge" :class="gasto.Tipo === 'hotel' ? 'bg-primary' : 'bg-warning text-dark'">
                {{ gasto.Tipo === 'hotel' ? 'Hotel' : 'Restaurante' }}
              </span>
            </td>
            <td>{{ gasto.Descripcion }}</td>
            <td>{{ gasto.NumeroCheque || '-' }}</td>
            <td>{{ gasto.NumeroCuentaCheque || '-' }}</td>
            <td>Q.{{ Number(gasto.Cantidad).toFixed(2) }}</td>
            <td>
              <button class="btn btn-warning btn-sm me-2" @click="abrirModalEditar(gasto)">Editar</button>
              <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(gasto)">Eliminar</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ✅ Modal Registrar/Editar -->
    <div v-if="mostrarModalRegistrar" class="modal-backdrop">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modoEdicion ? 'Editar Gasto' : 'Registrar Gasto' }}</h5>
          <button type="button" class="btn-close" @click="cerrarModalRegistrar"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-md-12">
              <label class="form-label">Descripción</label>
              <input type="text" v-model="gastoActual.Descripcion" class="form-control" />
            </div>
            <div class="col-md-6">
              <label class="form-label">No. Cheque</label>
              <input type="text" v-model="gastoActual.NumeroCheque" class="form-control" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Cuenta Cheque</label>
              <input type="text" v-model="gastoActual.NumeroCuentaCheque" class="form-control" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Cantidad (Q)</label>
              <input type="number" v-model.number="gastoActual.Cantidad" min="0" step="0.01" class="form-control" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Tipo</label>
              <select v-model="gastoActual.Tipo" class="form-select">
                <option value="hotel">Hotel</option>
                <option value="restaurante">Restaurante</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer mt-3">
          <button class="btn btn-secondary" @click="cerrarModalRegistrar">Cancelar</button>
          <button class="btn btn-primary" @click="guardarGasto">
            {{ modoEdicion ? 'Actualizar' : 'Registrar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ✅ Modal Confirmar Eliminar -->
    <div v-if="mostrarModalEliminar" class="modal-backdrop">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
          <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
        </div>
        <div class="modal-body">
          <p>¿Eliminar el gasto de <strong>Q{{ gastoEliminar?.Cantidad }}</strong> con descripción <strong>{{ gastoEliminar?.Descripcion }}</strong>?</p>
        </div>
        <div class="modal-footer mt-3">
          <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
          <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "GastosGeneralesHotel",
  data() {
    return {
      gastos: [],
      filtroTipo: "",
      mostrarModalRegistrar: false,
      modoEdicion: false,
      mostrarModalEliminar: false,
      gastoEliminar: null,
      gastoActual: {
        Descripcion: "",
        NumeroCheque: "",
        NumeroCuentaCheque: "",
        Cantidad: "",
        Tipo: "hotel"
      },
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerGastos() {
      try {
        const params = this.filtroTipo ? { tipo: this.filtroTipo } : {};
        const { data } = await axios.get(`${API_URL}/gastos-generales-hotel`, { params });
        this.gastos = data;
      } catch (error) {
        console.error(error);
      }
    },
    abrirModalRegistrar() {
      this.mostrarModalRegistrar = true;
      this.modoEdicion = false;
      this.gastoActual = {
        Descripcion: "",
        NumeroCheque: "",
        NumeroCuentaCheque: "",
        Cantidad: "",
        Tipo: "hotel"
      };
    },
    abrirModalEditar(gasto) {
      this.gastoActual = { ...gasto };
      this.modoEdicion = true;
      this.mostrarModalRegistrar = true;
    },
    cerrarModalRegistrar() {
      this.mostrarModalRegistrar = false;
      this.modoEdicion = false;
      this.gastoActual = {
        Descripcion: "",
        NumeroCheque: "",
        NumeroCuentaCheque: "",
        Cantidad: "",
        Tipo: "hotel"
      };
    },
    async guardarGasto() {
      const { Descripcion, Cantidad } = this.gastoActual;
      if (!Descripcion || Cantidad === "") {
        this.mostrarAlerta("Descripción y cantidad son obligatorias.", "danger");
        return;
      }

      try {
        if (this.modoEdicion) {
          await axios.put(`${API_URL}/gastos-generales-hotel/${this.gastoActual.IdGastoHotel}`, this.gastoActual);
          this.mostrarAlerta("Gasto actualizado correctamente");
        } else {
          await axios.post(`${API_URL}/gastos-generales-hotel`, this.gastoActual);
          this.mostrarAlerta("Gasto registrado correctamente");
        }
        this.cerrarModalRegistrar();
        this.obtenerGastos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar gasto.", "danger");
      }
    },
    abrirModalEliminar(gasto) {
      this.gastoEliminar = { ...gasto };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.gastoEliminar = null;
    },
    async confirmarEliminar() {
      if (!this.gastoEliminar) return;
      try {
        await axios.delete(`${API_URL}/gastos-generales-hotel/${this.gastoEliminar.IdGastoHotel}`);
        this.mostrarAlerta("Gasto eliminado correctamente");
        this.obtenerGastos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar gasto", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    }
  },
  mounted() {
    this.obtenerGastos();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 500px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
